import { Space } from 'antd'
import { BaseButton } from 'components/elements/BaseButton'
import { FC } from 'react'
import { TNotificationStatus } from 'types'
import { useNotificationChatActionMutation } from '../api'

export const ChatNotificationAction: FC<{
 notficationId?: any
 acceptInvite?: () => void
 acceptLoading?: boolean
 status?: TNotificationStatus
 leadId?: any
 onSuccessJoin?: () => void
}> = ({ onSuccessJoin, status, notficationId, leadId }) => {
 const [joinChat, { isLoading }] = useNotificationChatActionMutation()
 const [ignoreChat, { isLoading: ignoreLoading }] =
  useNotificationChatActionMutation()

 const handleClickChatAction = async (st: 'join' | 'ignore') => {
  if (st === 'join') {
   await joinChat({
    type: 'joined',
    lead_id: leadId,
    notification_id: notficationId,
   })

   onSuccessJoin?.()
  } else {
   await ignoreChat({
    type: 'ignored',
    lead_id: leadId,
    notification_id: notficationId,
   })
   //    onSuccessAction?.()
  }
 }

 return (
  <>
   {status === 'pending' && (
    <Space className="my-2 d-flex">
     <BaseButton
      size="small"
      shape="round"
      onClick={() => handleClickChatAction('join')}
      loading={isLoading}
      buttonStyle="solid"
      buttonType="primary"
     >
      Join
     </BaseButton>

     <BaseButton
      shape="round"
      size="small"
      buttonStyle="outline"
      buttonType="primary"
      onClick={() => handleClickChatAction('ignore')}
      loading={ignoreLoading}
     >
      Ignore
     </BaseButton>
    </Space>
   )}
   {/* {status === 'leadtransferred' && (
    <div className="text-primary">Lead Transferred</div>
   )} */}
   {status === 'joined' && <div className="text-success">Joined The Chat</div>}
   {status === 'ignored' && (
    <div style={{ color: 'red' }}>Chat Request Ignored</div>
   )}
  </>
 )
}
